import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getOnboardingState } from '../../../store/selectors';
import { fireGTM } from '../../../gtm/gtmUtil';
import { degreePairingPage_GTM } from '../../../gtm/datalayers/degreePairingDataLayers.json';
import { getTop3Path } from '../../../util/paths';

function ReplaceCareerLink(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const replaceLinkTextPrimary = {
    color: `${props.tenant.primary}`,
  };

  const handleReplaceCareerSelect = (replaceCareerProps) => {
    fireGTM(degreePairingPage_GTM.replaceCareerLink);

    // No need to save anything in the DB here because if they've selected/deselected a path, that will update the DB
    // Save whatever current career choices the user has selected
    if (props.onboarding) {
      dispatch({
        type: 'SET_CAREER_TAB',
        payload: {
          careerInfo: {
            ...props.onboarding.degreeChoices,
          },
          careerTabSelected: props.onboarding.careerTabSelected,
          currentTab: props.onboarding.currentTab,
        },
      });

      // TODO: send user to original page that allows them to choose their top 3 careers after playing the game
      const { history, location } = props;

      if (history)
        history.push(getTop3Path(replaceCareerProps.tenant, location));
    }
  };

  const mainContent = (
    <button
      className="replace-career-link"
      data-cy="replace-career-link"
      onClick={() => {
        handleReplaceCareerSelect(props);
      }}
      onKeyPress={(e) => {
        if (['Enter'].includes(e.key)) {
          handleReplaceCareerSelect(props);
        }
      }}
      type="button"
      tabIndex={0}
      style={replaceLinkTextPrimary}
    >
      {t('Replace current career choice')}
    </button>
  );

  return mainContent;
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);

  return { onboarding };
}

export default withRouter(connect(mapStateToProps)(ReplaceCareerLink));
